import React from 'react';
import AddInsuranceCompany from '../components/AddInsuranceCompany';

const InsuranceCompanyFormPage: React.FC = () => <AddInsuranceCompany />;

export default InsuranceCompanyFormPage;
